module.exports = __webpack_public_path__ + "img/co.51e2b21a.svg";